var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"iq-answer-source-link",attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"iq-answer-source-link__label"},[_vm._v("How to: "+_vm._s(_vm.title))]),_c('span',{staticClass:"iq-answer-source-link__arrow",attrs:{"aria-hidden":"true"}},[_vm._v("↗")])])
}
var staticRenderFns = []

export { render, staticRenderFns }